import React from 'react';
import { useLocation } from 'react-router-dom';

const WHATSAPP_NUMBER = '919789112382';

const FeedbackButton = () => {
  const location = useLocation();

  const getPageName = () => {
    const path = location.pathname;
    if (path === '/') return 'Home';
    if (path === '/about') return 'About Us';
    if (path === '/services') return 'Services';
    if (path === '/contact') return 'Contact Us';
    if (path === '/faq') return 'FAQ';
    return 'Website';
  };

  const handleFeedbackClick = () => {
    const pageName = getPageName();
    const feedbackMessage = `Hello! I would like to share my feedback about your website.

*FEEDBACK - Bill Gates Offshore Crew Manning*

*Page Visited:* ${pageName}
*Date:* ${new Date().toLocaleDateString()}

*My Feedback/Suggestions:*
[Please share your feedback, suggestions, or experience here]

Thank you!`;

    const encodedMessage = encodeURIComponent(feedbackMessage);
    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  const buttonStyles = {
    position: 'fixed',
    bottom: '24px',
    right: '24px',
    width: '60px',
    height: '60px',
    borderRadius: '50%',
    backgroundColor: '#25D366',
    color: '#fff',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '32px',
    boxShadow: '0 4px 20px rgba(37, 211, 102, 0.5)',
    zIndex: 9999,
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
  };

  return (
    <button
      onClick={handleFeedbackClick}
      style={buttonStyles}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'scale(1.1)';
        e.currentTarget.style.boxShadow = '0 6px 24px rgba(37, 211, 102, 0.6)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
        e.currentTarget.style.boxShadow = '0 4px 20px rgba(37, 211, 102, 0.5)';
      }}
      aria-label="Send feedback via WhatsApp"
      title="Send Feedback"
    >
     <img
        src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
        alt="WhatsApp"
        style={{ width: '24px', height: '24px' }}
      />
    </button>
  );
};

export default FeedbackButton;
